import React from 'react'
import { motion } from "framer-motion";

function MenuNav({ isMenuOpen, toggleMenu }) {
    return (
        <button
            onClick={toggleMenu}
            className="md:hidden relative w-10 h-10 flex flex-col justify-center items-center bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-sunday_primary focus:ring-opacity-50"
            aria-label="Toggle mobile menu"
            aria-expanded={isMenuOpen}
        >
            <div className="w-6 h-5 relative flex flex-col justify-between">
                <motion.span
                    className="w-full h-0.5 bg-gray-700 rounded-full origin-center"
                    animate={{
                        rotate: isMenuOpen ? 45 : 0,
                        y: isMenuOpen ? 9 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                />
                <motion.span
                    className="w-full h-0.5 bg-gray-700 rounded-full"
                    animate={{
                        opacity: isMenuOpen ? 0 : 1,
                        x: isMenuOpen ? 20 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                />
                <motion.span
                    className="w-full h-0.5 bg-gray-700 rounded-full origin-center"
                    animate={{
                        rotate: isMenuOpen ? -45 : 0,
                        y: isMenuOpen ? -9 : 0,
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                />
            </div>
        </button>
    )
}

export default MenuNav
